import React from 'react'
import axios from 'axios'
import store from './store'
import { setLoading, unsetLoading } from './store/actions/loading'

let baseURL: string
switch (process.env.REACT_APP_NODE_ENV) {
  case 'local':
    baseURL = process.env.REACT_APP_LOCAL_API_URL
    break
  case 'development':
    baseURL = process.env.REACT_APP_DEV_API_URL
    break
  case 'base':
    baseURL = process.env.REACT_APP_BASE_API_URL
    break
  case 'staging':
    baseURL = process.env.REACT_APP_STAGING_API_URL
    break
  case 'production':
    baseURL = process.env.REACT_APP_PROD_API_URL
    break
  case 'test':
    baseURL = process.env.REACT_APP_TEST_API_URL
    break
  default:
    baseURL = process.env.REACT_APP_DEV_API_URL
    break
}

axios.defaults.baseURL = baseURL

// axiosでリクエストをかける度にheaderにjwtを仕込む
axios.interceptors.request.use(
  request => {
    store.dispatch(setLoading())
    console.log('axios request')
    const state = store.getState()
    if (state.auth.token) {
      request.headers.Authorization = state.auth.token
    }
    return request
  },
  function (error) {
    return Promise.reject(error)
  }
)

// レスポンスにインターセプト
axios.interceptors.response.use(response => {
  // setTimeout(() => {
  //   store.dispatch(unsetLoading())
  // }, 2000)
  store.dispatch(unsetLoading())
  return response
})
